import styled from 'styled-components'

export const VideoContainer = styled.div`
    width: 100%;
    max-width: 1750px;
    display: flex;
    margin: 0 auto;
`

export const VideoEl = styled.video`
    width: 100%;
`